import { useState, useEffect } from 'react';
export function useIsAtBottom() {
    const [isAtBottom, setIsAtBottom] = useState(true);
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight + 30;
            const documentHeight = document.documentElement.scrollHeight;
            if (scrollTop + windowHeight >= documentHeight ||
                window.innerHeight > documentHeight) {
                setIsAtBottom(true);
            }
            else {
                setIsAtBottom(false);
            }
        };
        window.addEventListener('load', handleScroll);
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        return () => {
            window.addEventListener('load', handleScroll);
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [isAtBottom]);
    return isAtBottom;
}
